import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { ActivitiesTable } from "../../../components/activity/ActivitiesTable";
import { useEffect } from "react";

const Activities = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Activities | Admin";
  }, []);

  const handleAddNew = () => {
    navigate("/admin/activity/add");
  };

  return (
    <div id="activities_page_container" className="space-y-6">
      <header className="space-y-4">
        <div>
          <h1 id="activities_page_title" className="text-3xl font-bold text-foreground">Activities</h1>
          <p className="text-muted-foreground">Manage resource activities</p>
        </div>
        <div className="flex justify-end">
          <Button id="activities_page_add_btn" onClick={handleAddNew} className="bg-yellow-400 hover:bg-yellow-500 text-black">
            <Plus className="h-4 w-4" />
            Add New Activity
          </Button>
        </div>
      </header>

      <main id="activities_page_main">
        <ActivitiesTable />
      </main>
    </div>
  );
};

export default Activities;
